import React from 'react';
import SuccessIcon from '../../icons/check-circle.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { ManageBooking, ReturnToBookingPortal } from './buttons';
import { BookingConfirmedProps } from './types';
import { useTranslation } from 'react-i18next';

export const BookingConfirmed = ({ guests, time, date, restaurantName, bookingId, linkTo }: BookingConfirmedProps) => {
	const { t } = useTranslation();
	return (
		<ResultPageLayout headerIcon={SuccessIcon} iconAltText={t('titles.booking_confirmed')}>
			<ResultPageLayout.Title>{t('titles.booking_confirmed')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_confirmed_prefix')}{' '}
					<b>{guests}</b>{' '}
					{guests > 1 ? t('labels.guests') : t('labels.guest')}{' '}
					{t('messages.booking_confirmed_on_connector')}{' '}
					<b>{date}</b>{' '}
					{t('messages.booking_confirmed_time_connector')}{' '}
					<b>{time}</b>{' '}
					{t('messages.booking_confirmed_restaurant_connector')}{' '}
					<b>{restaurantName}</b>{' '}
					{t('messages.booking_confirmed_suffix')}
				</p>
				<p>{t('messages.booking_email_notice')}</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<ReturnToBookingPortal to={linkTo} />
				<ManageBooking to={`/booking/${bookingId}`} />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
